// @flow
import { titleToSlug } from '../../../services/titleToSlug'
import { numberToCurrency } from '../../../services/numberToCurrency'
import catalogMedia from './assets/catalog'

export default {
  productID: 'hardCoded.productID.ineditGlass',
  title: 'hardCoded.title.ineditGlass',
  slug: titleToSlug('hardCoded.title.ineditGlass'),
  catalog: {
    title: 'hardCoded.catalog.title.ineditGlass',
    catalogMedia,
    price: numberToCurrency('15'),
    color: '#0d171d'
  }
}
